export default "__VITE_ASSET__B3V70kWF__"